// extracted by mini-css-extract-plugin
export default {"cardElement":"PurchaseDetails_cardElement__3K+GA"};